import { Button, ButtonSize, ButtonVariant, OTPInput } from '@hourly-hds/components';
import { useState } from 'react';
import StepLayout from '../StepLayout';
import styles from './CodeVerification.module.css';

interface CodeVerificationProps {
  onSubmit: (code: string) => void;
  onReturn: () => void;
  error?: string;
}

const CodeVerification = ({ onSubmit, onReturn, error }: CodeVerificationProps) => {
  const [code, setCode] = useState('');

  return (
    <StepLayout>
      <StepLayout.Header>
        <StepLayout.Title>Enter Code</StepLayout.Title>
        <StepLayout.Description>
          We sent a verification code to your mobile number on file
        </StepLayout.Description>
      </StepLayout.Header>
      <StepLayout.Content>
        <div className={styles.otpContainer}>
          <OTPInput value={code} onChange={setCode} />
          {error && <span>{error}</span>}
        </div>
      </StepLayout.Content>
      <StepLayout.Actions>
        <Button label="Return" size={ButtonSize.Large} onClick={onReturn} />
        <Button
          label="Continue"
          disabled={!code || code.length < 4}
          onClick={() => onSubmit(code)}
          size={ButtonSize.Large}
          variant={ButtonVariant.Primary}
        />
      </StepLayout.Actions>
    </StepLayout>
  );
};

export default CodeVerification;
